module.exports = __webpack_public_path__ + "img/horizontal_3_5_7042.9ae0cfb1.png";